/* Paris Medicos Main JS v2 */
(function(){
  'use strict';
  var revealEls=document.querySelectorAll('[data-pm-reveal]');
  if('IntersectionObserver' in window && revealEls.length){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('pm-revealed');obs.unobserve(e.target);}
      });
    },{threshold:0.08,rootMargin:'0px 0px -40px 0px'});
    revealEls.forEach(function(el){obs.observe(el);});
  } else {
    revealEls.forEach(function(el){el.classList.add('pm-revealed');});
  }
  var header=document.querySelector('.shopify-section-group-header-group, header.header, .site-header, .header');
  if(header){
    var scrolled=false;
    function onScroll(){
      var s=window.scrollY>60;
      if(s!==scrolled){
        scrolled=s;
        header.classList.toggle('pm-header--scrolled',scrolled);
        header.style.boxShadow=scrolled?'0 2px 24px rgba(15,76,124,0.12)':'';
        header.style.backdropFilter=scrolled?'blur(12px)':'';
      }
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    onScroll();
  }
})();